webpackJsonp([15,39,40,41,42],{

/***/ 1253:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1254);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("1791942a", content, true, {});

/***/ }),

/***/ 1254:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".native .gnav[data-v-2920adce]{width:100%}.native .gnav-h1[data-v-2920adce]{margin:0;width:75%;max-width:217.77778px}.native .gnav-h1-a[data-v-2920adce]{display:block;min-width:200px}.native .gnav-right[data-v-2920adce]{margin-right:56px;width:56px;height:56px}.native .gnav-links[data-v-2920adce]{display:none}.native .gnav-links-a[data-v-2920adce]{display:block;margin-left:.5em;border-width:1px;border-style:solid;padding:.25em .5em;font-size:.85em}.native .gnav-info[data-v-2920adce]{text-align:right}.native .gnav-info-a[data-v-2920adce]{width:56px;height:56px;font-size:2em;font-family:Quicksand,sans-serif;line-height:1}.native .gnav-info-span[data-v-2920adce]{display:none}.native .gnav-info-open[data-v-2920adce]{display:none;margin:0;font-size:.75em}.native .gnav-menu[data-v-2920adce]{display:none}.native .gnav-menu-list[data-v-2920adce]{margin:0 auto;max-width:960px}.native .gnav-menu-item[data-v-2920adce]{width:100%;position:relative;border-width:1px;border-style:none solid none none}.native .gnav-menu-item[data-v-2920adce]:first-child{border-left-style:none}.native .gnav-menu-item:last-child .gnav-menu-sub-list[data-v-2920adce]{left:auto;right:0}.native .gnav-menu-item:hover>.gnav-menu-sub-list[data-v-2920adce]{display:block}.native .gnav-menu-a[data-v-2920adce]{width:100%;height:100%;padding:1em;position:relative;text-align:center;line-height:1.5;font-weight:700;font-size:.9em}.native .gnav-menu-sub-list[data-v-2920adce]{display:none;margin:auto;border-width:2px;border-style:solid;width:200%;position:absolute;left:0;bottom:0;z-index:1;-webkit-transform:translateY(100%);transform:translateY(100%)}.native .gnav-menu-sub-item[data-v-2920adce]{border-width:1px;border-style:solid none none}.native .gnav-menu-sub-item[data-v-2920adce]:first-child{border-top:none}.native .gnav-menu-sub-a[data-v-2920adce]{display:block;padding:1em 0 1em 2em;position:relative;line-height:1}.native .gnav-menu-sub-a[data-v-2920adce]:hover{-webkit-transition:all .15s;transition:all .15s}.native .gnav-menu-sub-a[data-v-2920adce]:hover:before{color:inherit;-webkit-transition:all .15s;transition:all .15s}.native .gnav-menu-sub-a[data-v-2920adce]:before{content:\"\\203A\";display:block;margin:auto;position:absolute;height:1em;top:0;left:.5em;bottom:.1em;line-height:1;font-size:1.5em;color:inherit}@media (min-width:768px){.native .gnav-h1[data-v-2920adce]{width:100%;max-width:350px;height:auto}.native .gnav-right[data-v-2920adce]{margin-right:0;width:100%;height:100%}.native .gnav-links[data-v-2920adce]{display:-webkit-box;display:-ms-flexbox;display:flex}.native .gnav-info-a[data-v-2920adce]{display:block;margin-top:.5em;width:auto;height:auto}.native .gnav-info-a .fa[data-v-2920adce]{margin-right:.2em}.native .gnav-info-open[data-v-2920adce]{display:-webkit-box;display:-ms-flexbox;display:flex}.native .gnav-info-span[data-v-2920adce]{display:inline}.native .gnav-menu-item:hover>.gnav-sub-list[data-v-2920adce],.native .gnav-menu[data-v-2920adce]{display:block}}@media (min-width:1025px){.native .gnav-links-a[data-v-2920adce]:hover{-webkit-transition:all .15s;transition:all .15s}}.desktop .gnav[data-v-2920adce],.smartphone .gnav[data-v-2920adce],.tablet .gnav[data-v-2920adce]{width:100%}.desktop .gnav-h1[data-v-2920adce],.smartphone .gnav-h1[data-v-2920adce],.tablet .gnav-h1[data-v-2920adce]{margin:0;width:75%;max-width:217.77778px}.desktop .gnav-h1-a[data-v-2920adce],.smartphone .gnav-h1-a[data-v-2920adce],.tablet .gnav-h1-a[data-v-2920adce]{display:block;min-width:200px}.desktop .gnav-right[data-v-2920adce],.smartphone .gnav-right[data-v-2920adce],.tablet .gnav-right[data-v-2920adce]{margin-right:56px;width:56px;height:56px}.desktop .gnav-links[data-v-2920adce],.smartphone .gnav-links[data-v-2920adce],.tablet .gnav-links[data-v-2920adce]{display:none}.desktop .gnav-links-a[data-v-2920adce],.smartphone .gnav-links-a[data-v-2920adce],.tablet .gnav-links-a[data-v-2920adce]{display:block;margin-left:.5em;border-width:1px;border-style:solid;padding:.25em .5em;font-size:.85em}.desktop .gnav-info[data-v-2920adce],.smartphone .gnav-info[data-v-2920adce],.tablet .gnav-info[data-v-2920adce]{text-align:right}.desktop .gnav-info-a[data-v-2920adce],.smartphone .gnav-info-a[data-v-2920adce],.tablet .gnav-info-a[data-v-2920adce]{width:56px;height:56px;font-size:2em;font-family:Quicksand,sans-serif;line-height:1}.desktop .gnav-info-span[data-v-2920adce],.smartphone .gnav-info-span[data-v-2920adce],.tablet .gnav-info-span[data-v-2920adce]{display:none}.desktop .gnav-info-open[data-v-2920adce],.smartphone .gnav-info-open[data-v-2920adce],.tablet .gnav-info-open[data-v-2920adce]{display:none;margin:0;font-size:.75em}.desktop .gnav-menu[data-v-2920adce],.smartphone .gnav-menu[data-v-2920adce],.tablet .gnav-menu[data-v-2920adce]{display:none}.desktop .gnav-menu-list[data-v-2920adce],.smartphone .gnav-menu-list[data-v-2920adce],.tablet .gnav-menu-list[data-v-2920adce]{margin:0 auto;max-width:960px}.desktop .gnav-menu-item[data-v-2920adce],.smartphone .gnav-menu-item[data-v-2920adce],.tablet .gnav-menu-item[data-v-2920adce]{width:100%;position:relative;border-width:1px;border-style:none solid none none}.desktop .gnav-menu-item[data-v-2920adce]:first-child,.smartphone .gnav-menu-item[data-v-2920adce]:first-child,.tablet .gnav-menu-item[data-v-2920adce]:first-child{border-left-style:none}.desktop .gnav-menu-item:last-child .gnav-menu-sub-list[data-v-2920adce],.smartphone .gnav-menu-item:last-child .gnav-menu-sub-list[data-v-2920adce],.tablet .gnav-menu-item:last-child .gnav-menu-sub-list[data-v-2920adce]{left:auto;right:0}.desktop .gnav-menu-item:hover>.gnav-menu-sub-list[data-v-2920adce],.smartphone .gnav-menu-item:hover>.gnav-menu-sub-list[data-v-2920adce],.tablet .gnav-menu-item:hover>.gnav-menu-sub-list[data-v-2920adce]{display:block}.desktop .gnav-menu-a[data-v-2920adce],.smartphone .gnav-menu-a[data-v-2920adce],.tablet .gnav-menu-a[data-v-2920adce]{width:100%;height:100%;padding:1em;position:relative;text-align:center;line-height:1.5;font-weight:700;font-size:.9em}.desktop .gnav-menu-sub-list[data-v-2920adce],.smartphone .gnav-menu-sub-list[data-v-2920adce],.tablet .gnav-menu-sub-list[data-v-2920adce]{display:none;margin:auto;border-width:2px;border-style:solid;width:200%;position:absolute;left:0;bottom:0;z-index:1;-webkit-transform:translateY(100%);transform:translateY(100%)}.desktop .gnav-menu-sub-item[data-v-2920adce],.smartphone .gnav-menu-sub-item[data-v-2920adce],.tablet .gnav-menu-sub-item[data-v-2920adce]{border-width:1px;border-style:solid none none}.desktop .gnav-menu-sub-item[data-v-2920adce]:first-child,.smartphone .gnav-menu-sub-item[data-v-2920adce]:first-child,.tablet .gnav-menu-sub-item[data-v-2920adce]:first-child{border-top:none}.desktop .gnav-menu-sub-a[data-v-2920adce],.smartphone .gnav-menu-sub-a[data-v-2920adce],.tablet .gnav-menu-sub-a[data-v-2920adce]{display:block;padding:1em 0 1em 2em;position:relative;line-height:1}.desktop .gnav-menu-sub-a[data-v-2920adce]:hover,.smartphone .gnav-menu-sub-a[data-v-2920adce]:hover,.tablet .gnav-menu-sub-a[data-v-2920adce]:hover{-webkit-transition:all .15s;transition:all .15s}.desktop .gnav-menu-sub-a[data-v-2920adce]:hover:before,.smartphone .gnav-menu-sub-a[data-v-2920adce]:hover:before,.tablet .gnav-menu-sub-a[data-v-2920adce]:hover:before{color:inherit;-webkit-transition:all .15s;transition:all .15s}.desktop .gnav-menu-sub-a[data-v-2920adce]:before,.smartphone .gnav-menu-sub-a[data-v-2920adce]:before,.tablet .gnav-menu-sub-a[data-v-2920adce]:before{content:\"\\203A\";display:block;margin:auto;position:absolute;height:1em;top:0;left:.5em;bottom:.1em;line-height:1;font-size:1.5em;color:inherit}.desktop .gnav-h1[data-v-2920adce],.tablet .gnav-h1[data-v-2920adce]{width:100%;max-width:350px;height:auto}.desktop .gnav-right[data-v-2920adce],.tablet .gnav-right[data-v-2920adce]{margin-right:0;width:100%;height:100%}.desktop .gnav-links[data-v-2920adce],.tablet .gnav-links[data-v-2920adce]{display:-webkit-box;display:-ms-flexbox;display:flex}.desktop .gnav-info-a[data-v-2920adce],.tablet .gnav-info-a[data-v-2920adce]{display:block;margin-top:.5em;width:auto;height:auto}.desktop .gnav-info-a .fa[data-v-2920adce],.tablet .gnav-info-a .fa[data-v-2920adce]{margin-right:.2em}.desktop .gnav-info-open[data-v-2920adce],.tablet .gnav-info-open[data-v-2920adce]{display:-webkit-box;display:-ms-flexbox;display:flex}.desktop .gnav-info-span[data-v-2920adce],.tablet .gnav-info-span[data-v-2920adce]{display:inline}.desktop .gnav-menu-item:hover>.gnav-sub-list[data-v-2920adce],.desktop .gnav-menu[data-v-2920adce],.tablet .gnav-menu-item:hover>.gnav-sub-list[data-v-2920adce],.tablet .gnav-menu[data-v-2920adce]{display:block}.desktop .gnav-links-a[data-v-2920adce]:hover{-webkit-transition:all .15s;transition:all .15s}.add-links[data-v-2920adce]{padding:5em 0;text-align:center;cursor:pointer}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/navigation/NavigationStandard1/NavigationStandard1.vue"],"names":[],"mappings":"AAmCA,+BACI,UAAY,CACf,AACD,kCACM,SAAU,AACV,UAAW,AACX,qBAAuB,CAC5B,AACD,oCACQ,cAAe,AACf,eAAiB,CACxB,AACD,qCACM,kBAAmB,AACnB,WAAY,AACZ,WAAa,CAClB,AACD,qCACM,YAAc,CACnB,AACD,uCACQ,cAAe,AACf,iBAAkB,AAClB,iBAAkB,AAClB,mBAAoB,AACpB,mBAAoB,AACpB,eAAiB,CACxB,AACD,oCACM,gBAAkB,CACvB,AACD,sCACQ,WAAY,AACZ,YAAa,AACb,cAAe,AACf,iCAAmC,AACnC,aAAe,CACtB,AACD,yCACQ,YAAc,CACrB,AACD,yCACQ,aAAc,AACd,SAAU,AACV,eAAiB,CACxB,AACD,oCACM,YAAc,CACnB,AACD,yCACQ,cAAe,AACf,eAAiB,CACxB,AACD,yCACQ,WAAY,AACZ,kBAAmB,AACnB,iBAAkB,AAClB,iCAAmC,CAC1C,AACD,qDACU,sBAAwB,CACjC,AACD,wEACU,UAAW,AACX,OAAS,CAClB,AACD,mEACU,aAAe,CACxB,AACD,sCACQ,WAAY,AACZ,YAAa,AACb,YAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,gBAAkB,AAClB,cAAgB,CACvB,AACD,6CACQ,aAAc,AACd,YAAa,AACb,iBAAkB,AAClB,mBAAoB,AACpB,WAAY,AACZ,kBAAmB,AACnB,OAAQ,AACR,SAAU,AACV,UAAW,AACX,mCAAoC,AACpC,0BAA4B,CACnC,AACD,6CACQ,iBAAkB,AAClB,4BAA8B,CACrC,AACD,yDACU,eAAiB,CAC1B,AACD,0CACQ,cAAe,AACf,sBAAuB,AACvB,kBAAmB,AACnB,aAAe,CACtB,AACD,gDACU,4BAA8B,AAC9B,mBAAsB,CAC/B,AACD,uDACY,cAAe,AACf,4BAA8B,AAC9B,mBAAsB,CACjC,AACD,iDACU,gBAAiB,AACjB,cAAe,AACf,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,MAAO,AACP,UAAW,AACX,YAAa,AACb,cAAe,AACf,gBAAiB,AACjB,aAAe,CACxB,AACD,yBAmBA,kCACQ,WAAY,AACZ,gBAAiB,AACjB,WAAa,CACpB,AACD,qCACQ,eAAgB,AAChB,WAAY,AACZ,WAAa,CACpB,AACD,qCACQ,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACrB,AACD,sCACQ,cAAe,AACf,gBAAiB,AACjB,WAAY,AACZ,WAAa,CACpB,AACD,0CACU,iBAAmB,CAC5B,AACD,yCACQ,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACrB,AACD,yCACQ,cAAgB,CACvB,AAID,kGACU,aAAe,CACxB,CACA,AACD,0BAmBA,6CACQ,4BAA8B,AAC9B,mBAAsB,CAC7B,CACA,AAqBD,kGAGI,UAAY,CACf,AACD,2GAGM,SAAU,AACV,UAAW,AACX,qBAAuB,CAC5B,AACD,iHAGQ,cAAe,AACf,eAAiB,CACxB,AACD,oHAGM,kBAAmB,AACnB,WAAY,AACZ,WAAa,CAClB,AACD,oHAGM,YAAc,CACnB,AACD,0HAGQ,cAAe,AACf,iBAAkB,AAClB,iBAAkB,AAClB,mBAAoB,AACpB,mBAAoB,AACpB,eAAiB,CACxB,AACD,iHAGM,gBAAkB,CACvB,AACD,uHAGQ,WAAY,AACZ,YAAa,AACb,cAAe,AACf,iCAAmC,AACnC,aAAe,CACtB,AACD,gIAGQ,YAAc,CACrB,AACD,gIAGQ,aAAc,AACd,SAAU,AACV,eAAiB,CACxB,AACD,iHAGM,YAAc,CACnB,AACD,gIAGQ,cAAe,AACf,eAAiB,CACxB,AACD,gIAGQ,WAAY,AACZ,kBAAmB,AACnB,iBAAkB,AAClB,iCAAmC,CAC1C,AACD,oKAGU,sBAAwB,CACjC,AACD,6NAGU,UAAW,AACX,OAAS,CAClB,AACD,8MAGU,aAAe,CACxB,AACD,uHAGQ,WAAY,AACZ,YAAa,AACb,YAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,gBAAkB,AAClB,cAAgB,CACvB,AACD,4IAGQ,aAAc,AACd,YAAa,AACb,iBAAkB,AAClB,mBAAoB,AACpB,WAAY,AACZ,kBAAmB,AACnB,OAAQ,AACR,SAAU,AACV,UAAW,AACX,mCAAoC,AACpC,0BAA4B,CACnC,AACD,4IAGQ,iBAAkB,AAClB,4BAA8B,CACrC,AACD,gLAGU,eAAiB,CAC1B,AACD,mIAGQ,cAAe,AACf,sBAAuB,AACvB,kBAAmB,AACnB,aAAe,CACtB,AACD,qJAGU,4BAA8B,AAC9B,mBAAsB,CAC/B,AACD,0KAGY,cAAe,AACf,4BAA8B,AAC9B,mBAAsB,CACjC,AACD,wJAGU,gBAAiB,AACjB,cAAe,AACf,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,MAAO,AACP,UAAW,AACX,YAAa,AACb,cAAe,AACf,gBAAiB,AACjB,aAAe,CACxB,AAoBD,qEAEI,WAAY,AACZ,gBAAiB,AACjB,WAAa,CAChB,AACD,2EAEI,eAAgB,AAChB,WAAY,AACZ,WAAa,CAChB,AACD,2EAEI,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AACD,6EAEI,cAAe,AACf,gBAAiB,AACjB,WAAY,AACZ,WAAa,CAChB,AACD,qFAEM,iBAAmB,CACxB,AACD,mFAEI,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AACD,mFAEI,cAAgB,CACnB,AAKD,sMAEM,aAAe,CACpB,AAmBD,8CACI,4BAA8B,AAC9B,mBAAsB,CACzB,AACD,4BACE,cAAe,AACf,kBAAmB,AACnB,cAAgB,CACjB","file":"NavigationStandard1.vue","sourcesContent":["\n.native[data-v-2920adce] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.native .gnav[data-v-2920adce] {\n    width: 100%;\n}\n.native .gnav-h1[data-v-2920adce] {\n      margin: 0;\n      width: 75%;\n      max-width: 217.77778px;\n}\n.native .gnav-h1-a[data-v-2920adce] {\n        display: block;\n        min-width: 200px;\n}\n.native .gnav-right[data-v-2920adce] {\n      margin-right: 56px;\n      width: 56px;\n      height: 56px;\n}\n.native .gnav-links[data-v-2920adce] {\n      display: none;\n}\n.native .gnav-links-a[data-v-2920adce] {\n        display: block;\n        margin-left: .5em;\n        border-width: 1px;\n        border-style: solid;\n        padding: .25em .5em;\n        font-size: .85em;\n}\n.native .gnav-info[data-v-2920adce] {\n      text-align: right;\n}\n.native .gnav-info-a[data-v-2920adce] {\n        width: 56px;\n        height: 56px;\n        font-size: 2em;\n        font-family: Quicksand, sans-serif;\n        line-height: 1;\n}\n.native .gnav-info-span[data-v-2920adce] {\n        display: none;\n}\n.native .gnav-info-open[data-v-2920adce] {\n        display: none;\n        margin: 0;\n        font-size: .75em;\n}\n.native .gnav-menu[data-v-2920adce] {\n      display: none;\n}\n.native .gnav-menu-list[data-v-2920adce] {\n        margin: 0 auto;\n        max-width: 960px;\n}\n.native .gnav-menu-item[data-v-2920adce] {\n        width: 100%;\n        position: relative;\n        border-width: 1px;\n        border-style: none solid none none;\n}\n.native .gnav-menu-item[data-v-2920adce]:first-child {\n          border-left-style: none;\n}\n.native .gnav-menu-item:last-child .gnav-menu-sub-list[data-v-2920adce] {\n          left: auto;\n          right: 0;\n}\n.native .gnav-menu-item:hover > .gnav-menu-sub-list[data-v-2920adce] {\n          display: block;\n}\n.native .gnav-menu-a[data-v-2920adce] {\n        width: 100%;\n        height: 100%;\n        padding: 1em;\n        position: relative;\n        text-align: center;\n        line-height: 1.5;\n        font-weight: bold;\n        font-size: .9em;\n}\n.native .gnav-menu-sub-list[data-v-2920adce] {\n        display: none;\n        margin: auto;\n        border-width: 2px;\n        border-style: solid;\n        width: 200%;\n        position: absolute;\n        left: 0;\n        bottom: 0;\n        z-index: 1;\n        -webkit-transform: translateY(100%);\n        transform: translateY(100%);\n}\n.native .gnav-menu-sub-item[data-v-2920adce] {\n        border-width: 1px;\n        border-style: solid none none;\n}\n.native .gnav-menu-sub-item[data-v-2920adce]:first-child {\n          border-top: none;\n}\n.native .gnav-menu-sub-a[data-v-2920adce] {\n        display: block;\n        padding: 1em 0 1em 2em;\n        position: relative;\n        line-height: 1;\n}\n.native .gnav-menu-sub-a[data-v-2920adce]:hover {\n          -webkit-transition: all 150ms;\n          transition: all 150ms;\n}\n.native .gnav-menu-sub-a[data-v-2920adce]:hover:before {\n            color: inherit;\n            -webkit-transition: all 150ms;\n            transition: all 150ms;\n}\n.native .gnav-menu-sub-a[data-v-2920adce]:before {\n          content: \"\\203A\";\n          display: block;\n          margin: auto;\n          position: absolute;\n          height: 1em;\n          top: 0;\n          left: .5em;\n          bottom: .1em;\n          line-height: 1;\n          font-size: 1.5em;\n          color: inherit;\n}\n@media (min-width: 768px) {\n.native[data-v-2920adce] {\n      /**\n *\n * Layout\n *\n */\n      /**\n * Columns\n */\n      /**\n * Component\n */\n      /**\n *\n * Application specific variables\n *\n */\n}\n.native .gnav-h1[data-v-2920adce] {\n        width: 100%;\n        max-width: 350px;\n        height: auto;\n}\n.native .gnav-right[data-v-2920adce] {\n        margin-right: 0;\n        width: 100%;\n        height: 100%;\n}\n.native .gnav-links[data-v-2920adce] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.native .gnav-info-a[data-v-2920adce] {\n        display: block;\n        margin-top: .5em;\n        width: auto;\n        height: auto;\n}\n.native .gnav-info-a .fa[data-v-2920adce] {\n          margin-right: .2em;\n}\n.native .gnav-info-open[data-v-2920adce] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.native .gnav-info-span[data-v-2920adce] {\n        display: inline;\n}\n.native .gnav-menu[data-v-2920adce] {\n        display: block;\n}\n.native .gnav-menu-item:hover > .gnav-sub-list[data-v-2920adce] {\n          display: block;\n}\n}\n@media (min-width: 1025px) {\n.native[data-v-2920adce] {\n      /**\n *\n * Layout\n *\n */\n      /**\n * Columns\n */\n      /**\n * Component\n */\n      /**\n *\n * Application specific variables\n *\n */\n}\n.native .gnav-links-a[data-v-2920adce]:hover {\n        -webkit-transition: all 150ms;\n        transition: all 150ms;\n}\n}\n.smartphone[data-v-2920adce],\n.tablet[data-v-2920adce],\n.desktop[data-v-2920adce] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.smartphone .gnav[data-v-2920adce],\n  .tablet .gnav[data-v-2920adce],\n  .desktop .gnav[data-v-2920adce] {\n    width: 100%;\n}\n.smartphone .gnav-h1[data-v-2920adce],\n    .tablet .gnav-h1[data-v-2920adce],\n    .desktop .gnav-h1[data-v-2920adce] {\n      margin: 0;\n      width: 75%;\n      max-width: 217.77778px;\n}\n.smartphone .gnav-h1-a[data-v-2920adce],\n      .tablet .gnav-h1-a[data-v-2920adce],\n      .desktop .gnav-h1-a[data-v-2920adce] {\n        display: block;\n        min-width: 200px;\n}\n.smartphone .gnav-right[data-v-2920adce],\n    .tablet .gnav-right[data-v-2920adce],\n    .desktop .gnav-right[data-v-2920adce] {\n      margin-right: 56px;\n      width: 56px;\n      height: 56px;\n}\n.smartphone .gnav-links[data-v-2920adce],\n    .tablet .gnav-links[data-v-2920adce],\n    .desktop .gnav-links[data-v-2920adce] {\n      display: none;\n}\n.smartphone .gnav-links-a[data-v-2920adce],\n      .tablet .gnav-links-a[data-v-2920adce],\n      .desktop .gnav-links-a[data-v-2920adce] {\n        display: block;\n        margin-left: .5em;\n        border-width: 1px;\n        border-style: solid;\n        padding: .25em .5em;\n        font-size: .85em;\n}\n.smartphone .gnav-info[data-v-2920adce],\n    .tablet .gnav-info[data-v-2920adce],\n    .desktop .gnav-info[data-v-2920adce] {\n      text-align: right;\n}\n.smartphone .gnav-info-a[data-v-2920adce],\n      .tablet .gnav-info-a[data-v-2920adce],\n      .desktop .gnav-info-a[data-v-2920adce] {\n        width: 56px;\n        height: 56px;\n        font-size: 2em;\n        font-family: Quicksand, sans-serif;\n        line-height: 1;\n}\n.smartphone .gnav-info-span[data-v-2920adce],\n      .tablet .gnav-info-span[data-v-2920adce],\n      .desktop .gnav-info-span[data-v-2920adce] {\n        display: none;\n}\n.smartphone .gnav-info-open[data-v-2920adce],\n      .tablet .gnav-info-open[data-v-2920adce],\n      .desktop .gnav-info-open[data-v-2920adce] {\n        display: none;\n        margin: 0;\n        font-size: .75em;\n}\n.smartphone .gnav-menu[data-v-2920adce],\n    .tablet .gnav-menu[data-v-2920adce],\n    .desktop .gnav-menu[data-v-2920adce] {\n      display: none;\n}\n.smartphone .gnav-menu-list[data-v-2920adce],\n      .tablet .gnav-menu-list[data-v-2920adce],\n      .desktop .gnav-menu-list[data-v-2920adce] {\n        margin: 0 auto;\n        max-width: 960px;\n}\n.smartphone .gnav-menu-item[data-v-2920adce],\n      .tablet .gnav-menu-item[data-v-2920adce],\n      .desktop .gnav-menu-item[data-v-2920adce] {\n        width: 100%;\n        position: relative;\n        border-width: 1px;\n        border-style: none solid none none;\n}\n.smartphone .gnav-menu-item[data-v-2920adce]:first-child,\n        .tablet .gnav-menu-item[data-v-2920adce]:first-child,\n        .desktop .gnav-menu-item[data-v-2920adce]:first-child {\n          border-left-style: none;\n}\n.smartphone .gnav-menu-item:last-child .gnav-menu-sub-list[data-v-2920adce],\n        .tablet .gnav-menu-item:last-child .gnav-menu-sub-list[data-v-2920adce],\n        .desktop .gnav-menu-item:last-child .gnav-menu-sub-list[data-v-2920adce] {\n          left: auto;\n          right: 0;\n}\n.smartphone .gnav-menu-item:hover > .gnav-menu-sub-list[data-v-2920adce],\n        .tablet .gnav-menu-item:hover > .gnav-menu-sub-list[data-v-2920adce],\n        .desktop .gnav-menu-item:hover > .gnav-menu-sub-list[data-v-2920adce] {\n          display: block;\n}\n.smartphone .gnav-menu-a[data-v-2920adce],\n      .tablet .gnav-menu-a[data-v-2920adce],\n      .desktop .gnav-menu-a[data-v-2920adce] {\n        width: 100%;\n        height: 100%;\n        padding: 1em;\n        position: relative;\n        text-align: center;\n        line-height: 1.5;\n        font-weight: bold;\n        font-size: .9em;\n}\n.smartphone .gnav-menu-sub-list[data-v-2920adce],\n      .tablet .gnav-menu-sub-list[data-v-2920adce],\n      .desktop .gnav-menu-sub-list[data-v-2920adce] {\n        display: none;\n        margin: auto;\n        border-width: 2px;\n        border-style: solid;\n        width: 200%;\n        position: absolute;\n        left: 0;\n        bottom: 0;\n        z-index: 1;\n        -webkit-transform: translateY(100%);\n        transform: translateY(100%);\n}\n.smartphone .gnav-menu-sub-item[data-v-2920adce],\n      .tablet .gnav-menu-sub-item[data-v-2920adce],\n      .desktop .gnav-menu-sub-item[data-v-2920adce] {\n        border-width: 1px;\n        border-style: solid none none;\n}\n.smartphone .gnav-menu-sub-item[data-v-2920adce]:first-child,\n        .tablet .gnav-menu-sub-item[data-v-2920adce]:first-child,\n        .desktop .gnav-menu-sub-item[data-v-2920adce]:first-child {\n          border-top: none;\n}\n.smartphone .gnav-menu-sub-a[data-v-2920adce],\n      .tablet .gnav-menu-sub-a[data-v-2920adce],\n      .desktop .gnav-menu-sub-a[data-v-2920adce] {\n        display: block;\n        padding: 1em 0 1em 2em;\n        position: relative;\n        line-height: 1;\n}\n.smartphone .gnav-menu-sub-a[data-v-2920adce]:hover,\n        .tablet .gnav-menu-sub-a[data-v-2920adce]:hover,\n        .desktop .gnav-menu-sub-a[data-v-2920adce]:hover {\n          -webkit-transition: all 150ms;\n          transition: all 150ms;\n}\n.smartphone .gnav-menu-sub-a[data-v-2920adce]:hover:before,\n          .tablet .gnav-menu-sub-a[data-v-2920adce]:hover:before,\n          .desktop .gnav-menu-sub-a[data-v-2920adce]:hover:before {\n            color: inherit;\n            -webkit-transition: all 150ms;\n            transition: all 150ms;\n}\n.smartphone .gnav-menu-sub-a[data-v-2920adce]:before,\n        .tablet .gnav-menu-sub-a[data-v-2920adce]:before,\n        .desktop .gnav-menu-sub-a[data-v-2920adce]:before {\n          content: \"\\203A\";\n          display: block;\n          margin: auto;\n          position: absolute;\n          height: 1em;\n          top: 0;\n          left: .5em;\n          bottom: .1em;\n          line-height: 1;\n          font-size: 1.5em;\n          color: inherit;\n}\n.tablet[data-v-2920adce],\n.desktop[data-v-2920adce] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.tablet .gnav-h1[data-v-2920adce],\n  .desktop .gnav-h1[data-v-2920adce] {\n    width: 100%;\n    max-width: 350px;\n    height: auto;\n}\n.tablet .gnav-right[data-v-2920adce],\n  .desktop .gnav-right[data-v-2920adce] {\n    margin-right: 0;\n    width: 100%;\n    height: 100%;\n}\n.tablet .gnav-links[data-v-2920adce],\n  .desktop .gnav-links[data-v-2920adce] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.tablet .gnav-info-a[data-v-2920adce],\n  .desktop .gnav-info-a[data-v-2920adce] {\n    display: block;\n    margin-top: .5em;\n    width: auto;\n    height: auto;\n}\n.tablet .gnav-info-a .fa[data-v-2920adce],\n    .desktop .gnav-info-a .fa[data-v-2920adce] {\n      margin-right: .2em;\n}\n.tablet .gnav-info-open[data-v-2920adce],\n  .desktop .gnav-info-open[data-v-2920adce] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.tablet .gnav-info-span[data-v-2920adce],\n  .desktop .gnav-info-span[data-v-2920adce] {\n    display: inline;\n}\n.tablet .gnav-menu[data-v-2920adce],\n  .desktop .gnav-menu[data-v-2920adce] {\n    display: block;\n}\n.tablet .gnav-menu-item:hover > .gnav-sub-list[data-v-2920adce],\n    .desktop .gnav-menu-item:hover > .gnav-sub-list[data-v-2920adce] {\n      display: block;\n}\n.desktop[data-v-2920adce] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.desktop .gnav-links-a[data-v-2920adce]:hover {\n    -webkit-transition: all 150ms;\n    transition: all 150ms;\n}\n.add-links[data-v-2920adce] {\n  padding: 5em 0;\n  text-align: center;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1255:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./NavigationStandard1.l.scss": 1256,
	"./NavigationStandard1.m.scss": 1258,
	"./NavigationStandard1.s.scss": 1260,
	"./NavigationStandard1.scss": 1262
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1255;

/***/ }),

/***/ 1256:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1257);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1257:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".gnav-links-a:hover{-webkit-transition:all .15s;transition:all .15s}", ""]);

// exports


/***/ }),

/***/ 1258:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1259);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1259:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".gnav-h1{width:100%;max-width:350px;height:auto}.gnav-right{margin-right:0;width:100%;height:100%}.gnav-links{display:-webkit-box;display:-ms-flexbox;display:flex}.gnav-info-a{display:block;margin-top:.5em;width:auto;height:auto}.gnav-info-a .fa{margin-right:.2em}.gnav-info-open{display:-webkit-box;display:-ms-flexbox;display:flex}.gnav-info-span{display:inline}.gnav-menu,.gnav-menu-item:hover>.gnav-sub-list{display:block}", ""]);

// exports


/***/ }),

/***/ 1260:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1261);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1261:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".gnav{width:100%}.gnav-h1{margin:0;width:75%;max-width:217.77778px}.gnav-h1-a{display:block;min-width:200px}.gnav-right{margin-right:56px;width:56px;height:56px}.gnav-links{display:none}.gnav-links-a{display:block;margin-left:.5em;border-width:1px;border-style:solid;padding:.25em .5em;font-size:.85em}.gnav-info{text-align:right}.gnav-info-a{width:56px;height:56px;font-size:2em;font-family:Quicksand,sans-serif;line-height:1}.gnav-info-span{display:none}.gnav-info-open{display:none;margin:0;font-size:.75em}.gnav-menu{display:none}.gnav-menu-list{margin:0 auto;max-width:960px}.gnav-menu-item{width:100%;position:relative;border-width:1px;border-style:none solid none none}.gnav-menu-item:first-child{border-left-style:none}.gnav-menu-item:last-child .gnav-menu-sub-list{left:auto;right:0}.gnav-menu-item:hover>.gnav-menu-sub-list{display:block}.gnav-menu-a{width:100%;height:100%;padding:1em;position:relative;text-align:center;line-height:1.5;font-weight:700;font-size:.9em}.gnav-menu-sub-list{display:none;margin:auto;border-width:2px;border-style:solid;width:200%;position:absolute;left:0;bottom:0;z-index:1;-webkit-transform:translateY(100%);transform:translateY(100%)}.gnav-menu-sub-item{border-width:1px;border-style:solid none none}.gnav-menu-sub-item:first-child{border-top:none}.gnav-menu-sub-a{display:block;padding:1em 0 1em 2em;position:relative;line-height:1}.gnav-menu-sub-a:hover,.gnav-menu-sub-a:hover:before{-webkit-transition:all .15s;transition:all .15s}.gnav-menu-sub-a:hover:before{color:inherit}.gnav-menu-sub-a:before{content:\"\\203A\";display:block;margin:auto;position:absolute;height:1em;top:0;left:.5em;bottom:.1em;line-height:1;font-size:1.5em;color:inherit}", ""]);

// exports


/***/ }),

/***/ 1262:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1263);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1263:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".gnav{width:100%}.gnav-h1{margin:0;width:75%;max-width:217.77778px}.gnav-h1-a{display:block;min-width:200px}.gnav-right{margin-right:56px;width:56px;height:56px}.gnav-links{display:none}.gnav-links-a{display:block;margin-left:.5em;border-width:1px;border-style:solid;padding:.25em .5em;font-size:.85em}.gnav-info{text-align:right}.gnav-info-a{width:56px;height:56px;font-size:2em;font-family:Quicksand,sans-serif;line-height:1}.gnav-info-span{display:none}.gnav-info-open{display:none;margin:0;font-size:.75em}.gnav-menu{display:none}.gnav-menu-list{margin:0 auto;max-width:960px}.gnav-menu-item{width:100%;position:relative;border-width:1px;border-style:none solid none none}.gnav-menu-item:first-child{border-left-style:none}.gnav-menu-item:last-child .gnav-menu-sub-list{left:auto;right:0}.gnav-menu-item:hover>.gnav-menu-sub-list{display:block}.gnav-menu-a{width:100%;height:100%;padding:1em;position:relative;text-align:center;line-height:1.5;font-weight:700;font-size:.9em}.gnav-menu-sub-list{display:none;margin:auto;border-width:2px;border-style:solid;width:200%;position:absolute;left:0;bottom:0;z-index:1;-webkit-transform:translateY(100%);transform:translateY(100%)}.gnav-menu-sub-item{border-width:1px;border-style:solid none none}.gnav-menu-sub-item:first-child{border-top:none}.gnav-menu-sub-a{display:block;padding:1em 0 1em 2em;position:relative;line-height:1}.gnav-menu-sub-a:hover,.gnav-menu-sub-a:hover:before{-webkit-transition:all .15s;transition:all .15s}.gnav-menu-sub-a:hover:before{color:inherit}.gnav-menu-sub-a:before{content:\"\\203A\";display:block;margin:auto;position:absolute;height:1em;top:0;left:.5em;bottom:.1em;line-height:1;font-size:1.5em;color:inherit}@media (min-width:768px){.gnav-h1{width:100%;max-width:350px;height:auto}.gnav-right{margin-right:0;width:100%;height:100%}.gnav-links{display:-webkit-box;display:-ms-flexbox;display:flex}.gnav-info-a{display:block;margin-top:.5em;width:auto;height:auto}.gnav-info-a .fa{margin-right:.2em}.gnav-info-open{display:-webkit-box;display:-ms-flexbox;display:flex}.gnav-info-span{display:inline}.gnav-menu,.gnav-menu-item:hover>.gnav-sub-list{display:block}}@media (min-width:1025px){.gnav-links-a:hover{-webkit-transition:all .15s;transition:all .15s}}", ""]);

// exports


/***/ }),

/***/ 1264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.component)?[_c('div',{class:['component', _vm.previewSize],style:(_vm.hideAll ? 'display:none' : '')},[_c('div',{on:{"click":function($event){_vm.isEditing = !_vm.lock}}},[_c('nav',{staticClass:"gnav theme-base-bg-color",style:(_vm.inPreview ? _vm.getThemeInlineStyle('background-color', 'base') : '')},[_c('div',{staticClass:"gnav-header container flex justify-between"},[_c('h1',{staticClass:"gnav-h1"},[_c('a',{staticClass:"gnav-h1-a"},[(_vm.logo)?[_c('mimic-amp-img',{attrs:{"image":_vm.logo}})]:[_c('div',{staticStyle:{"color":"red"}},[_vm._v("Settingsでロゴを設定して選択してください。")])]],2)]),_vm._v(" "),_c('div',{staticClass:"gnav-right flex column justify-between items-end"},[_c('div',{staticClass:"gnav-links justify-end items-center"},[(_vm.contents.linkIds.length > 0)?[_vm._l((_vm.contents.linkIds),function(id){return [_c('a',{staticClass:"gnav-links-a theme-accent-color theme-accent-border-color theme-accent-bg-color-hover",style:(_vm.inPreview ? _vm.getThemeInlineStyle('color', 'accent') + ';' + _vm.getThemeInlineStyle('border-color', 'accent') : '')},[_vm._v(_vm._s(_vm.getPageById(id).title.rendered))])]})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"gnav-info"},[_c('a',{staticClass:"gnav-info-a flex justify-center items-center"},[_c('i',{staticClass:"fa fa-phone",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"gnav-info-span"},[_vm._v(_vm._s(_vm.contents.tel))])]),_vm._v(" "),_c('p',{staticClass:"gnav-info-open"},[_vm._v("受付時間："+_vm._s(_vm.contents.open))])])])]),_vm._v(" "),_c('div',{staticClass:"gnav-menu theme-main-bg-color",style:(_vm.inPreview ? _vm.getThemeInlineStyle('background-color', 'main') : '')},[_c('div',{staticClass:"container"},[(_vm.contents.menuIds.length === 0)?[_c('div',{staticClass:"add-links"},[_vm._v("\n                  ナビゲーションのリンク先を追加してください\n                ")])]:[_c('ul',{staticClass:"gnav-menu-list flex justify-around"},[_vm._l((_vm.contents.menuIds),function(id,i){return [_c('li',{key:i,staticClass:"gnav-menu-item flex justify-center items-center theme-accent-border-color",style:(_vm.inPreview ? _vm.getThemeInlineStyle('border-color', 'accent') : '')},[_c('a',{staticClass:"gnav-menu-a flex justify-center items-center theme-accent-color-hover"},[_vm._v(_vm._s(_vm.getPageById(id).title.rendered))]),_vm._v(" "),(_vm.pages.length > 0 && _vm.getSubPagesById(id).length > 0)?[_c('ul',{staticClass:"gnav-menu-sub-list theme-accent-border-color theme-base-bg-color",style:(_vm.inPreview ? _vm.getThemeInlineStyle('border-color', 'accent') + ';' + _vm.getThemeInlineStyle('background-color', 'base') : '')},[_vm._l((_vm.getSubPagesById(id)),function(sub){return [_c('li',{staticClass:"gnav-menu-sub-item theme-accent-border-color",style:(_vm.inPreview ? _vm.getThemeInlineStyle('border-color', 'accent') : '')},[_c('a',{staticClass:"gnav-menu-sub-a theme-accent-color theme-accent-bg-color-hover",style:(_vm.inPreview ? _vm.getThemeInlineStyle('color', 'accent') : '')},[_vm._v(_vm._s(sub.title.rendered))])])]})],2)]:_vm._e()],2)]})],2)]],2)])])])]),_vm._v(" "),_c('el-dialog',{attrs:{"width":"75%","title":"ナビゲーションコンポーネントのコンテンツを編集","visible":_vm.isEditing},on:{"update:visible":function($event){_vm.isEditing=$event}}},[_c('el-form',{attrs:{"model":_vm.contents}},[_c('el-form-item',{attrs:{"label":"電話番号","label-width":_vm.labelWidth}},[(_vm.settings.contact.tel)?[_c('el-autocomplete',{staticClass:"width-50",attrs:{"fetch-suggestions":_vm.telAutoComplete,"placeholder":"Please Input"},model:{value:(_vm.contents.tel),callback:function ($$v) {_vm.$set(_vm.contents, "tel", $$v)},expression:"contents.tel"}})]:[_c('el-input',{staticClass:"width-50",attrs:{"auto-complete":"off"},model:{value:(_vm.contents.tel),callback:function ($$v) {_vm.$set(_vm.contents, "tel", $$v)},expression:"contents.tel"}})]],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"受付時間","label-width":_vm.labelWidth}},[_c('el-input',{staticClass:"width-50",attrs:{"auto-complete":"off"},model:{value:(_vm.contents.open),callback:function ($$v) {_vm.$set(_vm.contents, "open", $$v)},expression:"contents.open"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"リンクボタンの追加 (3つまで)","label-width":_vm.labelWidth}},[_c('select-links',{attrs:{"limit":3},model:{value:(_vm.contents.linkIds),callback:function ($$v) {_vm.$set(_vm.contents, "linkIds", $$v)},expression:"contents.linkIds"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"ナビゲーションボタンの追加","label-width":_vm.labelWidth}},[_c('select-links',{attrs:{"limit":6},model:{value:(_vm.contents.menuIds),callback:function ($$v) {_vm.$set(_vm.contents, "menuIds", $$v)},expression:"contents.menuIds"}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('component-form-footer',{on:{"delete":function($event){_vm.deleteComponent()},"cancel":function($event){_vm.isEditing = false},"update":function($event){_vm.updateComponent()}}})],1)],1)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentFormFooter_vue__ = __webpack_require__(450);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e587aeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentFormFooter_vue__ = __webpack_require__(453);
function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e587aeb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentFormFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e587aeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentFormFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_ComponentFormFooter__ = __webpack_require__(131);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'component-form-footer': __WEBPACK_IMPORTED_MODULE_1__components_forms_ComponentFormFooter__["default"]
  },
  data: function data() {
    return {
      name: this.$options.name,
      newPosition: this.index + 1,
      isEditing: false,
      extensions: []
    };
  },

  props: {
    index: { type: Number, default: null },
    bus: { type: Object, default: null },
    positionMax: { type: Number, default: null },
    component: { type: Object, default: null },
    components: { type: Array, default: null },
    hideAll: { type: Boolean, default: false },
    lock: { type: Boolean, default: false },
    previewSize: { type: String, default: 'native' },
    inPreview: { type: Boolean, default: false }
  },
  computed: {
    contents: {
      get: function get() {
        return this.component.contents;
      }
    },
    url: {
      get: function get() {
        return this.$store.getters['wordpress/account/url'];
      }
    },
    meta: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].components[this.component.id].meta;
      }
    },
    posts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/all'];
      }
    },
    publishedPosts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/published'];
      }
    },
    pages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/all'];
      }
    },
    publishedPages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/published'];
      }
    },
    media: {
      get: function get() {
        return this.$store.getters['wordpress/media/all'];
      }
    },
    themes: {
      get: function get() {
        return this.$store.getters['wordpress/themes/all'];
      }
    },
    settings: {
      get: function get() {
        return this.$store.getters['wordpress/settings/all'];
      }
    },
    sectionId: {
      get: function get() {
        return this.componentId(this);
      }
    },
    sectionClass: {
      get: function get() {
        return this.meta.file + ' ' + this.meta.file + '-' + this._uid + ' ' + (this.contents.bg.isCustom ? this.meta.file + '-' + this._uid + '-bg' : 'theme-base-bg-color') + ' slide';
      }
    },
    sectionClassArray: {
      get: function get() {
        return [this.meta.file, 'slide', 'theme-base-bg-color'];
      }
    },
    sectionStyle: {
      get: function get() {
        return this.contents.bg.isCustom ? 'background-color:' + this.contents.bg.color : '';
      }
    },
    containerClass: {
      get: function get() {
        return (this.contents.fullWidth ? '' : 'container') + (this.contents.padding.y ? ' py' + this.contents.padding.y : '');
      }
    },
    containerClassArray: {
      get: function get() {
        return [this.contents.fullWidth ? '' : 'container', 'py' + this.contents.padding.y];
      }
    },
    gridClass: {
      get: function get() {
        return 'grid grid-mx' + this.contents.layout.margin + ' grid-my' + this.contents.layout.margin + ' grid-1-' + this.contents.layout.s + ' grid-1-' + this.contents.layout.m + '-m grid-1-' + this.contents.layout.l + '-l';
      }
    },
    gridClassArray: {
      get: function get() {
        return ['grid', 'grid-mx' + this.contents.layout.margin, 'grid-my' + this.contents.layout.margin, 'grid-1-' + this.contents.layout.s, 'grid-1-' + this.contents.layout.m + '-m', 'grid-1-' + this.contents.layout.l + '-l'];
      }
    }
  },
  methods: {
    /**
     各コンポーネントに付与するIDを返す関数
     */
    componentId: function componentId(that) {
      return that.component ? that.component.meta.file + '-' + that._uid : that.meta.file + '-' + that._uid;
    },

    /**
     * uuid生成関数
     *
     * @see https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript/2117523#2117523
     */
    uuidv4: function uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
        return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
      });
    },

    /**
     * 文字色／背景色のインラインスタイルを取得する関数
     */
    getThemeInlineStyle: function getThemeInlineStyle(prop, type) {
      return prop + ': rgba(' + this.themes.colors[type].rgba.r + ', ' + this.themes.colors[type].rgba.g + ', ' + this.themes.colors[type].rgba.b + ', ' + this.themes.colors[type].rgba.a + ')';
    },

    /**
     * 引数で与えられるIDの固定ページを返す関数
     */
    getPageById: function getPageById(id) {
      return this.pages.find(function (page) {
        return page.id === id;
      });
    },

    /**
     * 引数で与えられるIDの固定ページの子ページを返す関数
     */
    getSubPagesById: function getSubPagesById(id) {
      return this.pages.filter(function (page) {
        return page.parent === id && page.status === 'publish';
      });
    },

    /**
     * 適用ボタンを押すとthis.components.contentsからHTMLとCSSを
     * 生成してupdateイベントを発火する
     *
     * 適用ボタンを押すとthis.component.htmlとthis.component.cssを更新する
     */
    updateComponent: function updateComponent() {
      if (false) console.log('Running updateComponent of ' + this.name + '...');

      this.component.html = this.generateHtml(this.component.contents);
      this.component.css = this.generateCss(this.component.contents);
      this.$emit('update', { component: this.component, newPosition: this.newPosition });
      this.isEditing = false;
    },

    updateComponentUid: function updateComponentUid() {
      /**
       * this._uid は vue でコンポーネントが生成された際に発行される。
       * この値は発行時にユニークであるため、あとでコンポーネントが追加されたり
       * コンポーネント入れ替え時に新規に発行されても、最初に発行された this._uid とは被らない（はず）。
       * updateComponentUid が呼び出されたらイベントバスで uid-updated イベントを発火して、
       * this.component._uid に this._uid を代入して最新の this._uid をコンポーネント内に保持する
       *
       */
      if (this.component._uid !== this._uid) {
        if (false) console.log('%c_uid has been changed: ' + this.component._uid + ' -> ' + this._uid, 'color:blue');
        this.bus.$emit('uid-updated', this);
        this.component._uid = this._uid;
        if (false) console.log('%c_uid has been updated: this.component._uid = ' + this.component._uid, 'color:teal');
      }
    },

    updateComponentAndUid: function updateComponentAndUid() {
      this.updateComponentUid();
      this.updateComponent();
    },

    /**
     * コンポーネント削除用のdeleteイベントを発火する
     */
    deleteComponent: function deleteComponent() {
      this.$emit('delete');
      this.isEditing = false;
    }
  },
  /**
   * コンポーネント生成時にHTMLとCSSを生成してupdateイベントを発火する
   */
  created: function created() {
    if (!this.component._uid) this.component._uid = this._uid;
    if (this.component.uid) delete this.component.uid;
    this.updateComponent();
  },
  /**
   * コンポーネントマウント時にmountedイベントを発火する
   */
  mounted: function mounted() {
    this.$emit('mounted');
    this.bus.$on('update-child', this.updateComponentAndUid);
  }
});

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MimicAmpImg_vue__ = __webpack_require__(455);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e0f36de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MimicAmpImg_vue__ = __webpack_require__(461);
function injectStyle (ssrContext) {
  __webpack_require__(459)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e0f36de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MimicAmpImg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e0f36de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MimicAmpImg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectLinks_vue__ = __webpack_require__(618);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36fbd416_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectLinks_vue__ = __webpack_require__(702);
function injectStyle (ssrContext) {
  __webpack_require__(700)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36fbd416"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectLinks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36fbd416_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectLinks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavigationStandard1_vue__ = __webpack_require__(821);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2920adce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavigationStandard1_vue__ = __webpack_require__(1264);
function injectStyle (ssrContext) {
  __webpack_require__(1253)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2920adce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavigationStandard1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2920adce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavigationStandard1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'component-form-footer',
  methods: {
    onDelete: function onDelete() {
      this.$emit('delete');
    },
    onCancel: function onCancel() {
      this.$emit('cancel');
    },
    onUpdate: function onUpdate() {
      this.$emit('update');
    }
  }
});

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(452);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("727fe8b8", content, true, {});

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ComponentFormFooter.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.onDelete()}}},[_vm._v("削除")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onCancel}},[_vm._v("キャンセル")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onUpdate}},[_vm._v("適用")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mimic-amp-img',
  props: ['image']
});

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(460);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("2434fe00", content, true, {});

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".amp-img[data-v-7e0f36de]{display:block;width:100%;position:relative;overflow:hidden!important}.amp-img-sizer[data-v-7e0f36de]{display:block!important}.amp-img-content[data-v-7e0f36de]{display:block;margin:auto;border:none!important;padding:0!important;width:0;max-width:100%;min-width:100%;height:0;max-height:100%;min-height:100%;position:absolute;top:0;left:0;right:0;bottom:0}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/mimic-amp/MimicAmpImg.vue"],"names":[],"mappings":"AAsBA,0BACE,cAAe,AACf,WAAY,AACZ,kBAAmB,AACnB,yBAA4B,CAC7B,AACD,gCACI,uBAA0B,CAC7B,AACD,kCACI,cAAe,AACf,YAAa,AACb,sBAAwB,AACxB,oBAAsB,AACtB,QAAS,AACT,eAAgB,AAChB,eAAgB,AAChB,SAAU,AACV,gBAAiB,AACjB,gBAAiB,AACjB,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,QAAU,CACb","file":"MimicAmpImg.vue","sourcesContent":["/**\n *\n * Layout\n *\n */\n/**\n * Columns\n */\n/**\n * Component\n */\n/**\n *\n * Application specific variables\n *\n */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Menu\n--------------------------*/\n.amp-img[data-v-7e0f36de] {\n  display: block;\n  width: 100%;\n  position: relative;\n  overflow: hidden !important;\n}\n.amp-img-sizer[data-v-7e0f36de] {\n    display: block !important;\n}\n.amp-img-content[data-v-7e0f36de] {\n    display: block;\n    margin: auto;\n    border: none !important;\n    padding: 0 !important;\n    width: 0;\n    max-width: 100%;\n    min-width: 100%;\n    height: 0;\n    max-height: 100%;\n    min-height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amp-img"},[_c('div',{staticClass:"amp-img-sizer",style:('padding-top:' + _vm.image.height / _vm.image.width * 100 + '%')}),_vm._v(" "),_c('img',{staticClass:"amp-img-content",attrs:{"src":_vm.image.src}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'select-links',
  props: {
    value: {
      type: Array
    },
    limit: {
      type: Number,
      default: 6
    }
  },
  computed: {
    pages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/all'];
      }
    },
    publishedPages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/published'];
      }
    }
  },
  methods: {
    onChange: function onChange(newValue) {
      this.$emit('input', newValue);
    }
  }
});

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(701);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("a098fdce", content, true, {});

/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SelectLinks.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 702:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"width-100",attrs:{"multiple":_vm.limit > 1,"multiple-limit":_vm.limit,"value-key":"link","value":_vm.value,"placeholder":"固定ページから選択"},on:{"change":_vm.onChange}},[_vm._l((_vm.publishedPages),function(page){return [_c('el-option',{key:page.link,staticClass:"el-opp",attrs:{"label":page.title.rendered,"value":page.id}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 821:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_ComponentBase__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mimic_amp_MimicAmpImg__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_SelectLinks__ = __webpack_require__(136);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navigation-standard-1',
  components: {
    'mimic-amp-img': __WEBPACK_IMPORTED_MODULE_1__components_mimic_amp_MimicAmpImg__["default"],
    'select-links': __WEBPACK_IMPORTED_MODULE_2__components_forms_SelectLinks__["default"]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_ComponentBase__["default"]],
  data: function data() {
    return {
      labelWidth: '15em'
    };
  },
  computed: {
    logo: function logo() {
      return this.$store.getters['wordpress/settings/logo'];
    }
  },
  methods: {
    /**
     * settingsで設定した電話番号を自動補完する
     */
    telAutoComplete: function telAutoComplete(query, callback) {
      var tels = [{ value: this.settings.contact.tel }];
      callback(tels);
    },
    /**
     * コンポーネントのHTMLを生成
     */
    generateHtml: function generateHtml(contents) {
      var _this = this;

      // if (contents.menuIds.length === 0) return ''

      var anchor = '';
      contents.linkIds.forEach(function (id) {
        if (!_this.getPageById(id)) return;

        anchor += '<a class="gnav-links-a theme-accent-color theme-accent-border-color theme-accent-bg-color-hover" href="' + _this.getPageById(id).link + '">' + _this.getPageById(id).title.rendered + '</a>';
      });

      var linksHtml = '';
      contents.menuIds.forEach(function (id) {
        if (!_this.getPageById(id)) return;

        var subsHtml = '';
        var subs = _this.getSubPagesById(id);
        if (subs.length > 0) {
          subsHtml += '<ul class="gnav-menu-sub-list theme-accent-border-color theme-base-bg-color">';
          subs.forEach(function (sub) {
            subsHtml += '<li class="gnav-menu-sub-item theme-accent-border-color"><a class="gnav-menu-sub-a theme-accent-color theme-accent-bg-color-hover" href="' + sub.link + '">' + sub.title.rendered + '</a></li>';
          });
          subsHtml += '</ul>';
        }
        linksHtml += '\n        <li class="gnav-menu-item flex justify-center items-center theme-accent-border-color">\n          <a class="gnav-menu-a flex justify-center items-center theme-accent-color-hover" href="' + _this.getPageById(id).link + '">' + _this.getPageById(id).title.rendered + '</a>\n          ' + subsHtml + '\n        </li>';
      });

      var html = '\n      <nav class="gnav theme-base-bg-color">\n        <div class="gnav-header container flex justify-between">\n          <h1 class="gnav-h1">\n            <a class="header-h1-a" href="' + this.url + '">\n              <amp-img width="' + this.logo.width + '" height="' + this.logo.height + '" layout="responsive" src="' + this.logo.src + '" alt="' + this.settings.site.owner + '\u30ED\u30B4\u753B\u50CF" attribution="' + this.settings.site.owner + ' All Rights Reserved."><p fallback>' + this.settings.site.owner + '</p>\n              </amp-img>\n            </a>\n          </h1>\n          <div class="gnav-right flex column justify-between items-end">\n            <div class="gnav-links flex justify-end items-center">' + anchor + '</div>\n            <div class="gnav-info">\n              <a class="gnav-info-a flex justify-center items-center" href="tel:' + contents.tel + '"><i class="fa fa-phone" aria-hidden="true"></i><span class="gnav-info-span">' + contents.tel + '</span></a>\n              <p class="gnav-info-open">\u53D7\u4ED8\u6642\u9593\uFF1A' + contents.open + '</p>\n            </div>\n          </div>\n        </div>\n        <div class="gnav-menu theme-main-bg-color">\n          <div class="container">\n            <ul class="gnav-menu-list flex justify-around">' + linksHtml + '</ul>\n          </div>\n        </div>\n      </nav>';
      return html.replace(/>\s+</g, '><').replace(/(\r\n|\n|\r)/gm, '').replace(/^\s+|\s+$/g, '');
    },
    /**
     * コンポーネントのCSSを生成
     */
    generateCss: function generateCss(contents) {
      var layout = __webpack_require__(1255)("./" + this.meta.file + '.scss');
      var theme = '';
      return { layout: layout, theme: theme };
    }
  },
  created: function created() {
    var _this2 = this;

    // contents.linkIds/contents.menuIdsに固定ページが見つからなければ削除する
    this.component.contents.linkIds = this.component.contents.linkIds.filter(function (id) {
      return _this2.getPageById(id);
    });
    this.component.contents.menuIds = this.component.contents.menuIds.filter(function (id) {
      return _this2.getPageById(id);
    });
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/15.293d03f5bb02dce92709.js